import { render, staticRenderFns } from "./catalogue.vue?vue&type=template&id=60af62ad"
import script from "./catalogue.vue?vue&type=script&lang=js"
export * from "./catalogue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports